module.exports = "/_next/static/images/text-room-fight-012dae27.png";